import { useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useActivityTracker = () => {
  const track = useCallback(async (eventType, data = {}) => {
    try {
      await fetch(`${API_URL}/api/activity`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ event_type: eventType, data }),
      });
    } catch { /* tracking must never break UX */ }
  }, []);

  return { track };
};
